<template>
  <div class="relative">
    <div>
      <div
        :id="id"
        type="button"
        :class="['w-full cursor-pointer px-3 gap-1 py-2 mt-1 border rounded-md hover:bg-hover sm:text-sm bg-surface text-primary flex items-center justify-between', props.class]"
        @click="toggleDropdown"
        aria-haspopup="listbox"
        :aria-expanded="showDropdown"
      >
        <slot name="display">
          <span class="font-medium">{{ selectedOptionLabel }}</span>
        </slot>
        <md-icon class="icon-inherit"><IconArrowDropDown /></md-icon>
      </div>

      <teleport to="body">
        <md-dialog 
          :open="showDropdown" 
          @close="showDropdown = false"
          class="select-dialog"
          quick
        >
          <div slot="headline" v-if="header">{{ header }}</div>
          <div slot="content">
            <md-list>
              <md-list-item
                v-for="(option, index) in internalOptions"
                :key="index"
                type="button"
                @click="selectOption(option)"
                :aria-selected="option.value === internalModelValue"
              >
                <div slot="headline">{{ option.label }}</div>
                <div slot="supporting-text" v-if="option.description" v-html="option.description"></div>
                <md-icon slot="end" v-if="option.value === internalModelValue" class="icon-checked"><IconCheck /></md-icon>
              </md-list-item>
            </md-list>
          </div>
          <div slot="actions">
            <md-text-button @click="showDropdown = false">{{ $t('forecastInfo.close') }}</md-text-button>
          </div>
        </md-dialog>
      </teleport>
    </div>

    
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useSettingsStore } from '../stores/settings';
import { getSettingsOptions } from '../constants/settingsOptions';

// Material Web Imports
import '@material/web/dialog/dialog.js';
import '@material/web/list/list.js';
import '@material/web/list/list-item.js';
import '@material/web/icon/icon.js';
import '@material/web/button/text-button.js';

import IconArrowDropDown from '~icons/material-symbols/arrow-drop-down-rounded';
import IconCheck from '~icons/material-symbols/check-rounded';

const props = defineProps({
  displayValue: [String, Number, Boolean, Object], // New prop for the displayed value on the button
  id: String,
  header: String,
  class: [String, Array, Object],
  settingKey: String, // New prop for settings integration
});

const showDropdown = ref(false);
const { t } = useI18n();

const settingsStore = useSettingsStore();

const internalOptions = computed(() => {
  const allOptions = getSettingsOptions(t);
  return allOptions[props.settingKey] || [];
});

const internalModelValue = computed(() => settingsStore[props.settingKey]);

const selectedOptionLabel = computed(() => {
  const selected = internalOptions.value.find(option => String(option.value) === String(internalModelValue.value));
  return props.displayValue? props.displayValue : selected ? selected.label : 'Select an option';
});

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const selectOption = (option) => {
  settingsStore.setSetting(props.settingKey, option.value);
  showDropdown.value = false;
};
</script>


<style scoped>
.select-dialog {
  min-width: 280px;
}

.icon-inherit {
  color: inherit;
}

.icon-checked {
  color: var(--color-rain);
}
</style>

